import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=48c3f40e&scoped=true"
import script from "./CustomSlider.vue?vue&type=script&lang=js"
export * from "./CustomSlider.vue?vue&type=script&lang=js"
import style0 from "./CustomSlider.vue?vue&type=style&index=0&id=48c3f40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c3f40e",
  null
  
)

export default component.exports